// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';
import { PledgeLine } from './pledge-line';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Pledge extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get amount() {
        return _(this.lines).sumBy((l) => l.amount || 0);
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  contactRegardingRetirementAccounts!: boolean;
  date!: Date;
  deleted?: Date;
  deletedBy?: string;
  nelandInEstate!: boolean;
  note?: string;
  personId!: number;
  lines!: PledgeLine[];
  person!: Person;
}

